import { lazy } from "react";
import reloadOnceForChunkError from "../Utils/chunkReloadGuard";
import { captureAppError, flushErrorReports } from "../Utils/errorReporting";

const retry = (fn, retriesLeft = 2, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        if (
          reloadOnceForChunkError(error, () => {
            captureAppError(error, { source: "lazy_route_import" });
            return flushErrorReports();
          })
        ) {
          reject(error);
          return;
        }
        if (retriesLeft === 1) {
          reject(error);
          return;
        }
        setTimeout(() => {
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

const retryLazy = (fn) => lazy(() => retry(fn));

export default retryLazy;
